<template>
    <div class="antialiased">
        <Sidebar />
        <div class="page">
            <Header hint="Cari pembayaran driver" />

            <div class="content">
                <div class="container">
                    <div class="page-header">
                        <div class="row d-flex justify-content-between">
                            <div class="col-auto">
                                <h2 class="page-title">Data Pelunasan Driver</h2>
                            </div>
                            <div class="col-auto">
                                <div class="btn-group mr-1">
                                    <div class="input-icon mr-1">
                                        <span class="input-icon-addon">
                                            <i class="fe fe-align-left"></i>
                                        </span>
                                        <select
                                            class="form-control"
                                            v-model="paginate.perPage"
                                            @change="_get"
                                            :disabled="loading"
                                        >
                                            <option
                                            :value="num"
                                            v-for="(num, i) in [10, 50, 100, 999]"
                                            :key="i"
                                            v-html="num == 999 ? 'Semua' : num"
                                            ></option>
                                        </select>
                                    </div>
                                    <button
                                        class="btn btn-white"
                                        v-html="ic('filter')"
                                        @click="_filter"
                                    ></button>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="alert alert-primary d-flex justify-content-between" v-if="idsPayment.length > 0">
                        <p class="m-0 font-sm">{{ idsPayment.length }} Pelunasan Driver dipilih</p>
                        <div>
                            <button 
                                class="btn btn-sm btn-primary mr-2"
                                :disabled="loading"
                                @click="_updateStatus('approve')">Approved
                            </button>
                            <button 
                                class="btn btn-sm btn-danger"
                                :disabled="loading"
                                @click="_updateStatus('reject')">Rejected
                            </button>
                        </div>
                    </div>

                    <Skeleton
                        type="table"
                        :length="10"
                        class="mt-3 bg-white"
                        v-if="loading"
                    />

                    <Nodata v-if="!loading && data.length === 0" />

                    <div class="box" v-if="!loading && data.length > 0">
                        <div class="card">
                            <div class="table-responsive">
                                <table class="table table-vcenter table-hover card-table table-striped table-control">
                                    <thead>
                                        <tr class="text-muted">
                                            <th>
                                                <label
                                                    class="form-check"
                                                    style="position: absolute; top: 4px; left: 13px;"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        :checked="data.length == idsPayment.length"
                                                        @click="_checkUncheck"
                                                        class="form-check-input"
                                                    />
                                                    <span class="form-check-label"></span>
                                                </label>
                                            </th>
                                            <th>No Invoice</th>
                                            <th>Toko</th>
                                            <th>Tanggal Pelunasan</th>
                                            <th>Salesman</th>
                                            <th>Pembayaran</th>
                                            <th></th>
                                            <th>Diinput Pada</th>
                                            <th>Status</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(payment, index) in data" :key="payment.id">
                                            <td  class="text-right pos-relative">
                                                <label
                                                    class="form-check"
                                                    style="
                                                        position: absolute;
                                                        top: 45%;
                                                        transform: translate(0, -49%);
                                                        left: 13px;
                                                    "
                                                >
                                                    <input
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        :disabled="['approved','rejected'].includes(payment.status)"
                                                        :value="payment.id"
                                                        v-model="idsPayment"
                                                    />
                                                    <span class="form-check-label"></span>
                                                </label>
                                            </td>
                                            <td>
                                                {{ payment.no_invoice }} <br />
                                                {{ payment.id_penjualan }}
                                            </td>
                                            <td>
                                                {{ payment.nama_toko }} <br />
                                                {{ payment.no_acc }} <br />
                                                {{ payment.cust_no }}
                                            </td>
                                            <td>
                                                {{ dFormat(payment.tanggal, "dMY") }}
                                            </td>
                                            <td>
                                                {{ payment.nama_salesman }} <br />
                                                {{ payment.nama_tim }}
                                            </td>
                                            <td style="text-transform: capitalize">
                                                {{ clearCase(payment.tipe) }} <br />
                                                {{ payment.bank }} <br />
                                            </td>
                                            <td style="white-space: nowrap">
                                                <span class="pull-right">{{ "Rp " + ribuan(payment.nominal) }}</span>
                                                <template v-for="(desc, index) in ['keterangan', 'no_bg', 'jatuh_tempo_bg']">
                                                    <br v-if="payment[desc] != '' && payment[desc] != null"  />
                                                    <span
                                                        class="pull-right"
                                                        style="text-transform: capitalize"
                                                        v-html="payment[desc]"
                                                    ></span>
                                                </template>
                                            </td>
                                            <td>
                                                <span v-html="dateFormat(payment.created_at).split(' ').join('<br>')" />
                                                <br />
                                                {{ payment.created_name }}
                                            </td>
                                            <td>
                                                <span
                                                v-html="payment.status"
                                                class="badge w-100"
                                                :class="
                                                    payment.status == 'waiting'
                                                    ? 'bg-warning'
                                                    : payment.status == 'rejected'
                                                    ? 'bg-danger'
                                                    : 'bg-success'
                                                "></span>
                                            </td>
                                            <td class="p-0 pos-relative">
                                                <div class="btn-group option center">
                                                    <button
                                                        title="Lihat Detail"
                                                        class="btn btn-white btn-pill"
                                                        v-html="ic('eye')"
                                                        @click="_detail(payment)"
                                                    ></button>
                                                    <button
                                                        title="Unapproved"
                                                        class="btn btn-white btn-pill"
                                                        v-if="payment.status == 'approved'"
                                                        @click="_unapprovePayment(payment.id)"
                                                        v-html="ic('refresh')"
                                                    ></button>
                                                    
                                                    <button
                                                        title="Edit"
                                                        class="btn btn-white btn-pill"
                                                        v-if="payment.status == 'waiting'"
                                                        @click="_edit(payment)"
                                                        v-html="ic('edit')"
                                                    ></button>
                                                    <button
                                                        title="Hapus"
                                                        class="btn btn-white btn-pill"
                                                        v-if="payment.status == 'waiting'"
                                                        @click="_delete(payment.id)"
                                                        v-html="ic('trash')"
                                                    ></button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>


                    <div class="container-fluid mt-4" v-if="!loading && data.length > 0">
                        <div class="row justify-content-center">
                            <div class="col-12 col-md-auto text-center">
                                <button class="btn btn-outline-primary mr-3" @click="_pagePrev">
                                Prev
                                </button>
                                <button class="btn btn-outline-primary" @click="_pageNext">
                                Next
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <FormFilter
            :config.sync="modals.filter.config"
            :initData="modals.filter.data"
            :dismiss.sync="modals.filter.dismiss"
            :isSubmit.sync="modals.filter.isSubmit"
            @submit="modals.filter.action"
        />
        <FormDetail
            :config.sync="modals.detail.config"
            :initData="modals.detail.data"
        />
        <FormPelunasan
            :config.sync="modals.form.config"
            :initData="modals.form.data"
            :isSubmit.sync="modals.form.isSubmit"
            @submit="modals.form.action"
        />
    </div>
</template>
<script>
import helper from "@/assets/js/helper.js";
import FormFilter from "./modals/filter";
import FormDetail from "./modals/detail";
import FormPelunasan from "./modals/form";

import { mapState, mapActions } from "vuex";

export default {
    name: "LaporanPelunasanDriver",
    components: { FormFilter, FormDetail, FormPelunasan },

    data() {
        return {
            loading: false,
            idsPayment:[],

            paginate: {
                currentPage: 1,
                totalRows: 0,
                perPage: 10,
                fromPage: 0,
            },
            filter: {
                id_salesman: "all",
                tipe: "semua",
                status: "semua",
                keyword: "",
                start_date: this.dateTime("ymd"),
                end_date: this.dateTime("ymd"),
                date_bg: "",
                ids_depo: [],
                per_page: "",
                page: "",
                id_mitra: "exclude",
            },
            modals:{
                filter: {
                    config: { view: false, title: null },
                    data: null,
                    isSubmit: false,
                    action: () => {},
                },
                form: {
                    config: { view: false, title: null },
                    data: null,
                    isSubmit: false,
                    action: () => {},
                },
                detail:{
                    config: { view: false, title: null },
                    data: null,
                },
                form: {
                    config: { view: false, title: null },
                    data: null,
                    isSubmit: false,
                    action: () => {},
                },
            },
            
        }
    },
    mixins: [helper],
    computed: {
        ...mapState("detail_pelunasan_driver", {
            data: (state) => state.data.driverPayment,
        }),
    },
    methods: {
        ...mapActions("detail_pelunasan_driver",[
            "getDriverPayment",
            "unapprovePayment",
            "bulkApprove",
            "bulkReject",
            "getTypePayment",
            "deletePayment",
            "updatePayment"
        ]),

        async _get(){
            this.loading = true
            this.getDriverPayment(this.filter)
            this.loading = false
        },
        _detail(payment){
            this.modals.detail.config = { view: true, title: "Detail Pelunasan" };
            this.modals.detail.data = payment;
        },
        _edit(payment){
            this.modals.form.config = { view: true, title: "Ubah Pembayaran" };
            this.modals.form.data = payment;
            this.modals.form.action = async (payloadUpdate) => {
                try{
                    this.loading = true
                    payloadUpdate.id_penjualan = payment.id_penjualan
                    payloadUpdate.id_payment = payment.id
                    const res = await this.updatePayment(payloadUpdate)
                    this.modals.form.config.view = false;
                    this.toast(res);
                    this._get()
                }catch(error) {
                    this.modals.form.config.view = false;
                    this.onError(err);
                    this.toast(error);
                }
            };
        },

        async _delete(id_payment){
            this.$swal({
                title: 'Kamu Yakin?',
                text: `Tidakan ini akan menghapus data pembayaran tersebut!`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Iya, Lanjutkan!'
            }).then( async (result) => {
                if (result.value) {
                    try {
                        this.loading = true
                        await this.deletePayment({
                            id_payment: id_payment,
                        })
                        this._get()
                    } catch (error) {
                        this.onError(error);
                        this.toast(error);
                    }
                   
                }
            })
        },

        _unapprovePayment(id_payment){
            this.$swal({
                title: 'Kamu Yakin?',
                text: `Tidakan ini akan mengembalikan data pembayaran yang sudah terapprove!`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Iya, Lanjutkan!'
            }).then( async (result) => {
                if (result.value) {
                    try {
                        this.loading = true
                        await this.unapprovePayment({
                            id_payment: id_payment,
                        })
                        this._get()
                    } catch (error) {
                        this.onError(error);
                        this.toast(error);
                    }
                }
            })
        },

        async _updateStatus(status){
            const payload = {ids_payment: this.idsPayment}
            this.$swal({
                title: 'Kamu Yakin?',
                text: `Tidakan ini akan mengubah status pembayaran menjadi ${status}!`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Iya, Lanjutkan!'
            }).then( async (result) => {
                if (result.value) {
                    this.loading = true
                    switch (status) {
                        case 'approve':
                            await this.bulkApprove(payload);
                            break;
                        case 'reject':
                            await this.bulkReject(payload);
                            break;
                        case 'unapprove':
                            await this.unapporvePayment(payload);
                            break;
                        default:
                            this.toast('Status undefined');
                    }
                    this._get();
                    this.idsPayment = [];
                }
            })
        },
        _checkUncheck(){
            const waitingPayments = this.data.filter(payment => payment.status === 'waiting');
            if (this.idsPayment.length != waitingPayments.length) {
                this.idsPayment = [];
                waitingPayments.forEach(payment => {
                    this.idsPayment.push(payment.id);
                });
            }else{
                this.idsPayment = [];
            }
        },
        _filter(){
            this.modals.filter.config = { view: true, title: "Filter" };
            this.modals.filter.action = (formData) => {
                for (const key in formData) {
                    this.filter[key] = formData[key];
                }
                this._get();
            };
        },
        _pagePrev() {
            if (this.paginate.currentPage > 1) {
                this.paginate.currentPage--;
                this._get();
            }
        },

        _pageNext() {
            if (this.paginate.to % this.paginate.perPage == 0) {
                this.paginate.currentPage++;
                this._get();
            }
        },

        _pageChange(page) {
            this.paginate.currentPage = page;
            this._get();
        },

        _search(keyword) {
            this.dataFilter.keyword = keyword;
            this.paginate.currentPage = 1;
            this._get();
        },
    },
    mounted() {
        this._get();
        this.getTypePayment()
    },
    
}
</script>
<style lang="scss" scoped src="./laporan-pelunasan-driver.scss" />

